import Vue from 'vue';
import NaverAd from './NaverAd.vue';

window.initNaverAd = function(config) {
    const el = document.querySelector('#naveradWrapper');
    if (!el) {
        console.warn('naveradWrapper element not found');
        return;
    }

    new Vue({
        el: '#naveradWrapper',
        render: h => h(NaverAd, {
            props: {
                searchQuery: config.searchQuery || '',
                adType: config.adType || 'powerLink',
                adData: config.adData || null
            }
        }),
    });
};